import { render, staticRenderFns } from "./StepHint.vue?vue&type=template&id=6cb94914&scoped=true&lang=pug&"
import script from "./StepHint.vue?vue&type=script&lang=ts&"
export * from "./StepHint.vue?vue&type=script&lang=ts&"
import style0 from "./StepHint.vue?vue&type=style&index=0&id=6cb94914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb94914",
  null
  
)

export default component.exports